import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
//import Glide from '@glidejs/glide';

@Component({
  selector: 'app-certificate-of-editing',
  templateUrl: './certificate-of-editing.component.html',
  styleUrls: ['./certificate-of-editing.component.scss']
})
export class CertificateOfEditingComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('人間の専門家による校正証明書 - Trinka AI');
    this.metaTagService.updateTag({ name: 'description', content: 'Enago（エナゴ）の専門校正者による校正証明書を発行します。世界的な出版基準やジャーナル基準を満たす学術論文を保証します。' });
    this.metaTagService.updateTag({ property: 'og:title', content: '人間の専門家による校正証明書 - Trinka AI' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Enago（エナゴ）の専門校正者による校正証明書を発行します。世界的な出版基準やジャーナル基準を満たす学術論文を保証します。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/features/certificate-of-editing' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '人間の専門家による校正証明書 - Trinka AI' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Enago（エナゴ）の専門校正者による校正証明書を発行します。世界的な出版基準やジャーナル基準を満たす学術論文を保証します。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/certificate-of-editing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/certificate-of-editing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/certificate-of-editing' });
  }

//   private glide: any;

//   experts = [
//     {
//       image: 'assets/images/features/coe/experts/medicine.jpeg',
//       flag: 'assets/images/features/coe/usa.png',
//       alt: 'doctor',
//       title: 'Doctor',
//       subtitle: 'of medicine',
//       experience: 31,
//       areas: ['Medicine', 'Pediatrics', 'Science', 'Biology', '+1']
//     },
//     {
//       image: 'assets/images/features/coe/experts/pyhsiology.jpeg',
//       flag: 'assets/images/features/coe/uk.png',
//       alt: 'Physiology',
//       title: 'PhD',
//       subtitle: 'Physiology',
//       experience: 20,
//       areas: ['Developmental neuroscience', 'Cognitive neuroscience', 'Cellular neuroscience', '+12']
//     },
//     {
//       image: 'assets/images/features/coe/experts/life-science.jpeg',
//       flag: 'assets/images/features/coe/usa.png',
//       alt: 'doctor',
//       title: 'PhD',
//       subtitle: 'Microbiology',
//       experience: 38,
//       areas: ['Biotechnology', 'Bioinformatics', 'Cancer research', '+25']
//     },
//     {
//       image: 'assets/images/features/coe/experts/ms.jpeg',
//       flag: 'assets/images/features/coe/usa.png',
//       alt: 'ms',
//       title: 'MS',
//       subtitle: 'Telecommunication & Chemistry',
//       experience: 37,
//       areas: ['Analytical chemistry', 'Applied chemistry', 'Coordination chemistry', '+11']
//     },
//     {
//       image: 'assets/images/features/coe/experts/economist.jpeg',
//       flag: 'assets/images/features/coe/usa.png',
//       alt: 'Economics',
//       title: 'MA',
//       subtitle: 'Economics',
//       experience: 34,
//       areas: ['Business administration', 'Human resources', 'International business', '+23']
//     },
//     {
//       image: 'assets/images/features/coe/experts/phd.png',
//       flag: 'assets/images/features/coe/usa.png',
//       alt: 'phd',
//       title: 'PhD',
//       subtitle: 'History',
//       experience: 20,
//       areas: ['Arts', 'History', 'Religion', '+1']
//     }
//   ];

//   ngAfterViewInit(): void {
//     this.glide = new Glide('.expertSlider', {
//       type: 'carousel',
//       startAt: 0,
//       perView: 3,
//       gap: 30,
//       autoplay: 3000,
//       hoverpause: true,
//       breakpoints: {
//         1024: { perView: 2 },
//         768: { perView: 1 }
//       }
//     });

//     this.glide.mount();
//   }

//   ngOnDestroy(): void {
//     if (this.glide) {
//       this.glide.destroy();
//     }
//   }

}
